import { type SystemStyleObject, defineStyleConfig } from '@chakra-ui/react';

import { BODY_CONFIG } from '../Body';
import { CAPTION_CONFIG } from '../Caption';
import { FOOTNOTE_CONFIG } from '../Footnote';
import { HEADING_CONFIG } from '../Heading';
import { HEADLINE_CONFIG } from '../Headline';
import { PARAGRAPH_CONFIG } from '../Paragraph';
import { TEXT_BUTTON_CONFIG } from '../TextButton';
import { OTHERS_CONFIG } from '../Others';

const addPrefixToKeys = (
  obj: { [key: string]: SystemStyleObject },
  prefix: string
): { [key: string]: SystemStyleObject } => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const newAcc: { [key: string]: SystemStyleObject } = { ...acc };
    newAcc[`${prefix}${key}`] = value;
    return newAcc;
  }, {} as { [key: string]: SystemStyleObject });
};

export const TextStyleConfig = defineStyleConfig({
  baseStyle: {
    fontFamily: 'lato',
  },
  variants: {
    ...addPrefixToKeys(TEXT_BUTTON_CONFIG, 'button'),
    ...addPrefixToKeys(FOOTNOTE_CONFIG, 'footnote'),
    ...addPrefixToKeys(HEADLINE_CONFIG, 'headline'),
    ...addPrefixToKeys(CAPTION_CONFIG, 'caption'),
    ...addPrefixToKeys(PARAGRAPH_CONFIG, 'paragraph'),
    ...addPrefixToKeys(BODY_CONFIG, 'body'),
    ...addPrefixToKeys(HEADING_CONFIG, 'heading'),
    ...addPrefixToKeys(OTHERS_CONFIG, 'others'),
  },
});
